import { gql } from "@apollo/client";

import { ACCOUNT_FIELDS } from "../fragments";

const USGetAccount = gql`
  ${ACCOUNT_FIELDS}
  query USGetAccount {
    USGetAccount {
      ...AccountFields
      groups {
        id
        name
        permissions {
          id
          name
          codename
        }
      }
    }
  }
`;

export default USGetAccount;
